import { Language } from 'locale/reducer';
import { LocaleKey } from 'locale/types';
import { LanguageOption } from 'components/Header/Header';

import { localeKeys } from 'enums/localeKeys';
import { countryCodes } from 'enums/keys';

export const languageNameMap = {
  en: 'english',
  de: 'german',
  es: 'spanish',
  ca: 'catalan',
  fr: 'french'
} as const;

export const languageTranslationsMap: Record<string, { title: LocaleKey; subtitle: LocaleKey }> = {
  english: {
    title: localeKeys.languageMenuEnglish,
    subtitle: localeKeys.languageMenuEnglishNative
  },
  german: {
    title: localeKeys.languageMenuGerman,
    subtitle: localeKeys.languageMenuGermanNative
  },
  spanish: {
    title: localeKeys.languageMenuSpanish,
    subtitle: localeKeys.languageMenuSpanishNative
  },
  catalan: {
    title: localeKeys.languageMenuCatalan,
    subtitle: localeKeys.languageMenuCatalanNative
  },
  french: {
    title: localeKeys.languageMenuFrench,
    subtitle: localeKeys.languageMenuFrenchNative
  }
};

export const countryCodeConvert = (value: string): Language => {
  return (value === countryCodes.en ? countryCodes.gb : value) as Language;
};

export const getAskPreviewImagePathForLanguage = (language: Language): string => {
  const supportedImageLanguages = ['en', 'de', 'es', 'ca'];
  const imageLanguage =
    supportedImageLanguages.find(supportedLanguage => supportedLanguage === language) ?? 'en';

  return `ask-preview-${imageLanguage}.webp`;
};

interface GetLanguages {
  allowedLanguages: LanguageOption[];
  currentLanguage: Language;
}

export const getLanguages = ({
  allowedLanguages,
  currentLanguage
}: GetLanguages): { selectedLanguage: LanguageOption; languages: LanguageOption[] } => {
  let languages = allowedLanguages;
  let currentLanguageOption = allowedLanguages.find(item => item.value === currentLanguage);

  if (!currentLanguageOption) {
    const language = languageNameMap[currentLanguage] ?? 'english';

    const languageTranslation = languageTranslationsMap[language];

    currentLanguageOption = {
      label: languageTranslation.title,
      value: currentLanguage
    };

    languages = [...allowedLanguages, currentLanguageOption];
  }

  const allowedLanguagesWithActive = languages.map(lang => ({
    ...lang,
    isActive: lang.value === currentLanguage
  })) as LanguageOption[];

  return {
    selectedLanguage: currentLanguageOption,
    languages: allowedLanguagesWithActive
  };
};
